import { ActionType } from '../infrastructure/actionTypes';
import { IShelfDivider } from "../infrastructure/interfaces";

export default (list: IShelfDivider[] = [], action: any) => {
    switch (action.type) {
        case ActionType.GET_SHELF_DIVIDERS_DONE:
            const { dividers } = action;
            return dividers
        case ActionType.UPDATE_SHELF_DIVIDERS_DONE:
            const { updatedShelfDivider } = action;
            list = list.map(d => {
                if (d.id !== updatedShelfDivider.id) {
                    return d;
                }

                return updatedShelfDivider;
            });
            return list;
        default:
            return list;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/shelfDividerList.ts